import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { I18nService } from '@core/i18n-legacy';

@Component({
  selector: 'rt-note-typing-indicator-message',
  templateUrl: './note-typing-indicator-message.component.html',
  styleUrls: ['./note-typing-indicator-message.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class NoteTypingIndicatorMessageComponent {
  @Input() public typingAdmins: Array<{ firstName: string; lastName: string }> = [];

  constructor(private i18n: I18nService) {}

  public get typingAdminsMessage(): string | undefined {
    if (this.typingAdmins.length > 1) {
      return this.i18n.translate('app.notes.typing_indicator.many_admins_are_typing');
    } else if (this.typingAdmins.length === 1) {
      const admin = this.typingAdmins[0];
      const adminName = admin.firstName || admin.lastName;
      return this.i18n.translate('app.notes.typing_indicator.admin_is_typing', { adminName });
    }

    return undefined;
  }
}
